import { isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import {
  BetSlipItem,
  BetSource,
  FobPropositionSelection,
  RacingBetType,
  ToteSelection,
} from '@mobi/betslip/types'
import { isMysteryDetails } from '@core/Data/Betting/selectionDetails'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent, trackKey } from '@core/Services/Analytics/track'

export const trackAddToBetSlip = (addedItem: BetSlipItem | BetSlipItem[]) => {
  const isMultiSelection = Array.isArray(addedItem) && addedItem.length > 1

  if (isMultiSelection) {
    const item = addedItem[0]
    trackAddToBetSlipBase({ source: item.betSource, betType: 'multi' })
    return
  }

  const { selection, selectionDetails, betSource } = Array.isArray(addedItem)
    ? addedItem[0]
    : addedItem

  if (betSource && selection && selectionDetails) {
    const betType =
      (selection as ToteSelection).betType || (selection as FobPropositionSelection).type

    const race = isRaceDetails(selectionDetails)
      ? selectionDetails.races[0]
      : isMysteryDetails(selectionDetails)
        ? selectionDetails.race
        : null

    const { meetingCode: raceCode, meetingName } = race || {
      meetingName: null,
      meetingCode: null,
    }

    trackAddToBetSlipBase({ source: betSource, raceCode, meetingName, betType })
  }
}

export const trackBetSlipClear = (): void => trackKey(keys.betslipCleared)

// =============
// Local Helpers
// =============

function trackAddToBetSlipBase(data: {
  betType: BetType
  source?: BetSource | null
  raceCode?: string | null
  meetingName?: string | null
}): void {
  trackEvent(keys.betslipBetAdded, { data })
}

// =====
// Types
// =====

type BetType = RacingBetType | 'multi'
